<script setup>
import {ref, onMounted} from 'vue'
import ButtonSave from "@/components/common/button/ButtonSave.vue";
import {handleError} from "@/utils/errors.js";
import {useI18n} from "vue-i18n";
import router from "@/router/index.js";
import {useRoute} from "vue-router";
import EntityForm from "@/components/common/Form.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {QrcodeCategoryEntity} from "@/entities/QrcodeCategoryEntity.js";
import {createCategory, getCategory, updateCategory} from "@/services/api/qrcode.js";

const { t } = useI18n();
const route = useRoute();
const loading = ref(false);
const id = route.params.id;
const isMounted = ref(false);
const form = ref(null);
const entity = ref(new QrcodeCategoryEntity());
const formData = ref(entity.value.getDefaultValues());
const fieldsDisabled = ref(false);

async function onSave() {
  try {
    const { valid } = await form.value.validate();
    if (!valid) return;
    loading.value = true;
    if (id) {
      await updateCategory(id, formData.value);
    } else {
      await createCategory(formData.value);
    }
    await router.push(entity.value.pages.list.route?.at(-1));
    message.success(t("common.messages.success.save"));
  } catch (error) {
    console.error(error);
    message.error(await handleError(error, t, formData?.value?.name));
  } finally { loading.value = false; }
}

onMounted(async () => {
  try {
    isMounted.value = false;
    if (id) {
      const response = await getCategory(id);
      formData.value = response.data;
    }
  } catch (e) { console.error(e); } finally { isMounted.value = true; }
});
</script>

<template>
  <BasePage :loading-mounted="isMounted" :entity="entity">
    <template #default>
      <EntityForm :entity="entity" v-model="formData" :disabled="fieldsDisabled" ref="form" />
      <ButtonSave :loading="loading" @click="onSave" />
    </template>
  </BasePage>
</template>

